import { useEffect } from "react";
import { useLocation } from "react-router";
import { Stack } from "@mui/material";
import { useAuth } from "src/context/AuthContext";
import { useCurrentPerson } from "src/utils/useCurrentPerson";
import { usePageMeta } from "src/hooks/usePageMeta";
import HeroSection from "src/components/HeroSection";
import LeadGenSection from "src/components/LeadGenSection";
import ProcessSection from "src/components/ProcessSection";

export default function Landing() {
    usePageMeta({ path: "/" });
    // Deep-link support for the "Miten toimii?" ad sitelink (/#nain-se-toimii).
    // The section renders after first paint, so the browser's native hash-scroll
    // misses it — scroll it into view once mounted (scroll-margin-top on the
    // section clears the sticky AppBar). No-op when there is no hash.
    const { hash } = useLocation();
    useEffect(() => {
        if (!hash) return;
        const el = document.getElementById(hash.slice(1));
        if (el) el.scrollIntoView({ behavior: "smooth" });
    }, [hash]);
    const { isAuthenticated } = useAuth();
    const person = useCurrentPerson();
    const greeting = isAuthenticated
        ? (person?.firstName || person?.email?.split("@")[0] || null)
        : null;

    return (
        <Stack spacing={{ xs: 5, md: 8 }}>
            <HeroSection greeting={greeting} />
            <LeadGenSection />
            <ProcessSection />
        </Stack>
    );
}
